<template>
  <section>
    <div class="columns is-multiline">
      <div class="column is-8">
        <div class="box">
          <h1 class="has-text-weight-semibold is-size-4">Change email address</h1>
          <b-field label="Current password">
            <b-input type="password" placeholder="******" password-reveal> </b-input>
          </b-field>
          <b-field label="New email address">
            <b-input type="email" value="john@" maxlength="30"> </b-input>
          </b-field>
          <b-field label="New email address confirmation">
            <b-input type="email" value="john@" maxlength="30"> </b-input>
          </b-field>
          <b-button type="is-success">Change email address</b-button>
        </div>
        <p class="has-text-justified pb-2 is-italic has-text-dark-orange">
          NOTE: Not implemented yet
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>
